import React from 'react';
import { useTaxForm } from './TaxFormContext';
import { CheckCircle, Circle } from 'lucide-react';

const steps = [
  { id: 1, title: 'Identity & Prefs', urdu: 'شناخت اور ترجیحات' },
  { id: 2, title: 'Incomes & WHT', urdu: 'آمدنی اور کٹوتیاں' },
  { id: 3, title: 'Personal Expenses', urdu: 'ذاتی اخراجات' },
  { id: 4, title: 'Wealth Declaration', urdu: 'کل اثاثہ جات' },
  { id: 5, title: 'Liabilities', urdu: 'مالی واجبات' },
  { id: 6, title: 'Review & Sign-off', urdu: 'حتمی جائزہ' },
];

export const StepProgress: React.FC = () => {
  const { currentStep } = useTaxForm();

  return (
    <div className="w-full max-w-4xl mx-auto mb-8">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <div key={step.id} className="flex items-center flex-1">
            <div className="flex flex-col items-center">
              <div
                className={`
                  flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300
                  ${
                    step.id < currentStep
                      ? 'bg-primary border-primary text-primary-foreground animate-scale-in'
                      : step.id === currentStep
                      ? 'border-primary bg-primary/10 text-primary animate-pulse'
                      : 'border-muted-foreground/30 text-muted-foreground'
                  }
                `}
              >
                {step.id < currentStep ? (
                  <CheckCircle className="w-6 h-6" />
                ) : (
                  <Circle className="w-6 h-6" />
                )}
              </div>
              <div className="mt-2 text-center">
                <div className={`text-sm font-medium ${
                  step.id <= currentStep ? 'text-primary' : 'text-muted-foreground'
                }`}>
                  {step.title}
                </div>
                <div className={`text-xs ${
                  step.id <= currentStep ? 'text-primary/70' : 'text-muted-foreground/70'
                } font-urdu`}>
                  {step.urdu}
                </div>
              </div>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`
                  flex-1 h-0.5 mx-4 transition-all duration-500
                  ${step.id < currentStep ? 'bg-primary' : 'bg-muted-foreground/30'}
                `}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};